
import React from 'react';
import { NotificationBell } from './NotificationBell';

export const Header: React.FC = () => {
  return (
    <header className="bg-white dark:bg-dark-secondary shadow-sm h-16 flex-shrink-0">
      <div className="flex items-center justify-end h-full px-4 sm:px-6 lg:px-8">
        <NotificationBell />
      </div>
    </header>
  );
};
